// src/pages/varmetab.jsx
import dynamic from 'next/dynamic';
import EnergieberegnerLayout from '../components/EnergieberegnerLayout';
import RequireProject from '../components/RequireProject';
import cardCss from '../styles/calculatorCard.module.css';

const VarmetabCalculator = dynamic(
    () => import('../components/calculators/varmetab/VarmetabCalculator'),
    { ssr: false }
);

export default function VarmetabPage() {
    return (
        <EnergieberegnerLayout title="Varmetabs-ramme">
            <RequireProject>
                <section className={cardCss.card}>
                    <VarmetabCalculator />
                </section>
            </RequireProject>
        </EnergieberegnerLayout>
    );
}
